import {CSSProperties, FC} from 'react';


export interface IIconAutoAvitoProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconAutoAvito: FC<IIconAutoAvitoProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 36 20"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" stroke="#000" strokeWidth=".225" d="M14.092 1.045a3.758 3.758 0 0 0-1.872.78c-.405.318-.398.308-2.165 2.62-.857 1.121-1.595 2.068-1.64 2.105-.044.036-1.262.386-2.705.778-1.52.413-2.796.797-3.034.912-.799.39-1.441 1.246-1.617 2.157-.113.582-.052 3.082.085 3.485.238.705.783 1.37 1.42 1.735.382.22 1.072.391 1.575.393.277.001.327.022.36.15.022.083.156.383.298.667.531 1.064 1.56 1.806 2.802 2.02.532.092.655.093 1.192.002 1.24-.21 2.284-.96 2.815-2.023.142-.284.276-.583.297-.665l.039-.15h11.716l.04.15c.02.082.155.382.297.666.534 1.069 1.568 1.811 2.814 2.022.538.09.66.09 1.192-.001 1.378-.239 2.55-1.18 2.992-2.403l.144-.4.689-.042c.379-.022.823-.077.987-.122.891-.242 1.72-1.053 2.043-1.999.133-.39.199-3.266.087-3.806-.154-.743-.622-1.481-1.188-1.874-.147-.102-.935-.493-1.75-.869L30.52 6.65l-1.268-2.023c-1.398-2.23-1.84-2.771-2.59-3.168-.876-.463-.596-.444-6.67-.458-3.015-.006-5.67.013-5.901.044Zm11.14 1.397c.536.087.98.312 1.33.676.153.157.885 1.259 1.628 2.448l1.35 2.162 1.68.78c.923.427 1.752.847 1.841.93.09.084.243.288.34.452.174.297.176.315.197 1.782.024 1.654-.018 1.909-.393 2.364-.322.391-.66.532-1.355.564l-.598.029-.08-.42c-.267-1.407-1.516-2.647-2.976-2.954-.596-.126-.97-.125-1.573.002-1.523.32-2.783 1.607-3.011 3.074l-.044.283H12.05l-.075-.399c-.198-1.04-1.043-2.138-2.018-2.618-.851-.42-1.646-.527-2.533-.34a3.902 3.902 0 0 0-2.819 2.38 3.936 3.936 0 0 0-.197.69l-.045.304-.417-.034c-.518-.041-.911-.248-1.205-.634-.328-.431-.366-.672-.342-2.168.024-1.497.069-1.67.542-2.086.31-.272.426-.31 3.4-1.113 1.424-.385 2.68-.746 2.79-.804.126-.066.826-.929 1.919-2.365.946-1.244 1.813-2.34 1.926-2.436.275-.232.835-.485 1.221-.55.482-.081 10.532-.08 11.033.001ZM9.224 12.787c.47.212 1.01.745 1.209 1.196a2.493 2.493 0 0 1-1.189 3.272c-.34.167-.45.187-1.044.187-.576 0-.713-.023-1.03-.172-1.22-.575-1.755-2.035-1.204-3.284.269-.608.98-1.196 1.653-1.366.43-.11 1.16-.033 1.605.167Zm19.198 0c.99.445 1.59 1.578 1.399 2.637-.21 1.164-1.102 1.97-2.253 2.037-.866.05-1.588-.265-2.107-.921-.504-.638-.651-1.63-.357-2.408.262-.692.982-1.327 1.713-1.512.43-.11 1.16-.033 1.605.167Z" clipRule="evenodd" />
        </svg>
    );
};
